import { ChatCommand, CommandTypes } from './types';

const SystemCommands: Record<string, true> = { [CommandTypes.PHONE]: true };

const CalendarCommands: Record<string, true> = {
  [CommandTypes.SHOW_CALENDAR_ITEM]: true,
  [CommandTypes.ADD_CALENDAR_ITEM]: true,
  [CommandTypes.DELETE_CALENDAR_ITEM]: true,
  [CommandTypes.UPDATE_CALENDAR_ITEM]: true,
};

const ChatRelatedCommands: Record<string, true> = {
  [CommandTypes.FOLLOW_UP_INPUT]: true,
  [CommandTypes.REPEAT_USER_MESSAGE]: true,
  [CommandTypes.REPEAT_WATSON_MESSAGE]: true,
};

export const isSystemCommand = (cmd: ChatCommand): boolean =>
  !!SystemCommands[cmd.type];
export const isCalendarCommand = (cmd: ChatCommand): boolean =>
  !!CalendarCommands[cmd.type];
export const isChatRelatedCommand = (cmd: ChatCommand): boolean =>
  !!ChatRelatedCommands[cmd.type];
export const isNavigationCommand = (cmd: ChatCommand): boolean =>
  cmd.type === CommandTypes.NAVIGATE;

export const parseCommandDateAndTime = ({
  date,
  time,
}: {
  date?: string;
  time?: string;
}): Date => {
  const parsedDate = date ? new Date(date) : new Date();

  if (time) {
    parsedDate.setHours(time.split(':')[0]);
    parsedDate.setMinutes(time.split(':')[1]);
  }

  return parsedDate;
};
